module.exports = __webpack_public_path__ + "static/img/icon_brzsxx@2x.da285964.png";